import Immutable from 'seamless-immutable';
import { handleActions } from 'redux-actions';
import { projects as actionTypes } from '$constants/action-types';
import { updateOrInserAll, updateOrInsert } from './helper';

const defaultState = Immutable({
  items: [],
  hasMore: false,
  isFetching: false
});

const reducer = {
  [actionTypes.FETCH_ALL_REQUEST](state) {
    return state.set('isFetching', true);
  },

  [actionTypes.FETCH_ALL_FAILURE](state) {
    return state.set('isFetching', false);
  },

  [actionTypes.FETCH_ALL_SUCCESS](state, action) {
    return updateOrInserAll(state, action.result)
                .set('hasMore', action.hasMore)
                .set('isFetching', false);
  },

  [actionTypes.CLEAR](state) {
    return defaultState;
  },

  [actionTypes.FETCH_SUCCESS](state, action) {
    return updateOrInsert(state, action.result);
  }
}

export default handleActions(reducer, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/projects.js